import React, {
  useEffect,
  useState,
  // useState
} from 'react'
import StepWizard from 'react-step-wizard'
import { Grid } from '@material-ui/core'
import Swal from 'sweetalert2'
import { useHistory } from 'react-router-dom'

import { useEligibility } from '../../../../../context/EligibilityContext'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'

import ElegibilidadEdit1 from './ElegibilidadSec1Edit'
import ElegibilidadSec2 from './ElegibilidadSec2Edit'
import ElegibilidadSec3 from './ElegibilidadSec3Edit'
import ElegibilidadSec4 from './ElegibilidadSec4Edit'
import ElegibilidadSec5 from './ElegibilidadSec5Edit'
import ElegibilidadSec6 from './ElegibilidadSec6Edit'

import { useFormElegibilidad } from '../../../../../context/ElegibilidadContext'
import { getFormByIdForm } from '../../../../../services/Elegibilidad/get'

const ElegibilidadFormEdit = (props) => {
  const {
    setIdElegibilityForm,
    editFormElegibility,
    setEditFormElegibility,
    setEligibilityForm,
  } = useFormElegibilidad()

  const { idForm } = props
  const [loadingData, setLoadingData] = useState(true)
  const [state] = useEligibility()
  const history = useHistory()

  useEffect(() => {
    if (idForm) {
      getEditFormElegibility(idForm)
    }
  }, [])

  const getEditFormElegibility = async (idForm) => {
    try {
      const response = await getFormByIdForm(idForm)
      if (response.Code === 200) {
        const values = response.Data
        setEditFormElegibility(values)
        // TODO: Cambiar todo el borrador para que solo use elegibilityForm
        setEligibilityForm(values)
        setIdElegibilityForm(values.IdElegibilityAnswer)
        setLoadingData(false)
      } else {
        Swal.fire({
          title: 'Opps!',
          text: 'Hubo un problema al abrir el formulario',
          timer: 3000,
        })
        history.goBack()
      }
    } catch (error) {
      Swal.fire({
        title: 'Opps!',
        text: 'Hubo un problema al abrir el formulario',
        timer: 3000,
      })
      console.log(error)
      history.goBack()
    }
  }

  return (
    <>
      {!loadingData && editFormElegibility !== '' ? (
        <div
          id="wizard-form"
          style={{
            overflow: 'hidden',
            backgroundColor: 'white',
            boxShadow: '0px 0px 12px -2px rgba(0,0,0,0.39)',
          }}
        >
          <div style={{ marginBottom: '48px' }}>
            <Grid
              container
              direction="row"
              justifyContent="flex-end"
              alignItems="center"
              spacing={1}
              style={{ marginTop: '18px', marginBottom: '16px' }}
            >
              <Grid item md={12} sm={12} xs={12}>
                <div
                  style={{
                    fontSize: '24px',
                    fontWeight: 'bold',
                    marginBottom: '8px',
                  }}
                >
                  <label className="formTitle">
                    Formulario Elegibilidad de Inversiones para Financiamiento
                  </label>
                </div>
                <label className="formDescription">
                  Rellene la información requerida para registrar el formulario
                </label>
              </Grid>
            </Grid>
          </div>

          <Grid
            container
            spacing={1}
            style={{ marginTop: '18px', marginBottom: '36px' }}
          >
            <Grid
              item
              xs={12}
              sm={2}
              md={2}
              className={`${
                state.step === 1
                  ? `stepper__title-active`
                  : `stepper__title-inactive`
              }`}
            >
              <label>SECCIÓN 1</label>
            </Grid>
            <Grid
              item
              xs={12}
              sm={2}
              md={2}
              className={`${
                state.step === 2
                  ? `stepper__title-active`
                  : `stepper__title-inactive`
              }`}
            >
              <label>SECCIÓN 2</label>
            </Grid>
            <Grid
              item
              xs={12}
              sm={2}
              md={2}
              className={`${
                state.step === 3
                  ? `stepper__title-active`
                  : `stepper__title-inactive`
              }`}
            >
              <label>SECCIÓN 3</label>
            </Grid>
            <Grid
              item
              xs={12}
              sm={2}
              md={2}
              className={`${
                state.step === 4
                  ? `stepper__title-active`
                  : `stepper__title-inactive`
              }`}
            >
              <label>SECCIÓN 4</label>
            </Grid>
            <Grid
              item
              xs={12}
              sm={2}
              md={2}
              className={`${
                state.step === 5
                  ? `stepper__title-active`
                  : `stepper__title-inactive`
              }`}
            >
              <label>SECCIÓN 5</label>
            </Grid>
            <Grid
              item
              xs={12}
              sm={2}
              md={2}
              className={`${
                state.step === 6
                  ? `stepper__title-active`
                  : `stepper__title-inactive`
              }`}
            >
              <label>SECCIÓN 6</label>
            </Grid>
          </Grid>

          <StepWizard initialStep={1}>
            <ElegibilidadEdit1 />
            <ElegibilidadSec2 />
            <ElegibilidadSec3 />
            <ElegibilidadSec4 />
            <ElegibilidadSec5 />
            <ElegibilidadSec6 />
          </StepWizard>
        </div>
      ) : (
        <Box className="loadingEditContainer">
          <Grid className="loadingSub">
            <CircularProgress />
          </Grid>
        </Box>
      )}
    </>
  )
}

export default ElegibilidadFormEdit
